<template>
    <DsMenu
        align="end"
        side="bottom"
        :sideOffset="8"
    >
        <template #menuTrigger>
            <DsButton
                size="md"
                trailing="fas fa-chevron-down"
                variant="secondary"
            >
                Actions
            </DsButton>
        </template>
        <DsMenuGroup>
            <DsMenuOption @click="router.push(`/accounts/${id}/payment-settings`)"> Enable payments </DsMenuOption>
            <DsMenuOption @click="router.push(`/accounts/${id}/two-way-texting`)"> Enable two-way texting </DsMenuOption>
            <DsMenuOption @click="router.push(`/accounts/${id}/progress-tracker`)"> Enable progress tracker </DsMenuOption>
            <DsMenuOption
                v-if="id !== currentUserMeta.userAccountId"
                @click="startShadowing(id)"
            >
                Shadow account
            </DsMenuOption>
        </DsMenuGroup>
        <DsMenuGroup>
            <DsMenuOption
                variant="destructive"
                @click="isDeactivateModalOpen = true"
            >
                Deactivate account
            </DsMenuOption>
        </DsMenuGroup>
    </DsMenu>
    <DeactivateAccountModal
        v-bind="props"
        v-model="isDeactivateModalOpen"
    />
</template>

<script setup lang="ts">
import DsMenuGroup from '@/components/design-system/menu/DsMenuGroup.vue';
import type { AccountApiResponse } from '@/employee-portal/accounts/Account.types';
import DeactivateAccountModal from '@/employee-portal/accounts/DeactivateAccountModal.vue';
import { useCurrentUserStore } from '@/stores/current-user.store';
import { useShadowAccountStore } from '@/stores/shared/shadow-account.store';
import DsButton from '@ds/button/DsButton.vue';
import DsMenu from '@ds/menu/DsMenu.vue';
import DsMenuOption from '@ds/menu/DsMenuOption.vue';
import { ref } from 'vue';
import { useRouter } from 'vue-router';

const props = defineProps<Pick<AccountApiResponse['account'], 'id' | 'name'>>();

const { currentUserMeta } = useCurrentUserStore();
const { startShadowing } = useShadowAccountStore();

const router = useRouter();

const isDeactivateModalOpen = ref(false);
</script>
